import Vue from 'vue';

export default Vue.extend({
  data() {
    return {
      options: [],
      state: [],
    }
  },
  computed: {
    field() {
      return this.params.colDef.field;
    }
  },
  watch: {
    'value': {
      immediate: true,
      deep: true,
      handler() { 
        this.state = this.params.value
        this.$forceUpdate()
      }
    },
    'params.colDef.options': {
      immediate: true,
      deep: true,
      handler() {
        this.options = this.params.values
        this.$forceUpdate()
      }
    },
  },
  mounted() {
    const { cascadeFrom, context, focusOnEditStart } = this.params;

    if (cascadeFrom) {
      // saving ref to child select
      context.editorRefs[cascadeFrom + 'SelectRef'] = this.$refs.selectRef;
      //  exposing update functions for clomuns that have a parent column
      context.editorUpdateMethods[cascadeFrom + 'Update'] = this.updateRefData;
    }

    this.$nextTick(() => {
      // i provided a property to country coll so the editor knows what to focus firs
      if (focusOnEditStart) this.$refs.selectRef.focus();
    });
  },
  updated() {
    const editorUpdateMethod = this.params.context.editorUpdateMethods[
      this.field + 'Update'
    ];

    if (!editorUpdateMethod) {
      return;
    }
    // parent cell editor will call child cell editor exposed update method
    editorUpdateMethod(this.state);
  },
  methods: {
    onInput() {
      this.$nextTick(() => {
        let refs = this.params.context.editorRefs;
        let childSelect = refs[this.field + 'SelectRef'];
        
        if (!childSelect) return;
        childSelect?.focus();
      })
    },
    updateRefData(newParentCellValue) {
      const { getRefData } = this.params.context;
      
      this.state = getRefData(newParentCellValue)?.[0];
      this.options = getRefData(newParentCellValue);
      console.log(newParentCellValue, this.options)
    },
    getValue() {
      return this.state;
    },
    isCancelBeforeStart() {
      return false;
    },
    isCancelAfterEnd() {
      return false;
    },
  },
  template: `
      <el-select ref="selectRef" class="select" v-model="state" @input="onInput()">
        <el-option v-for="option in options" :value="option" :label="option">
        </el-option>
      </el-select>
    `,  
});